import React from "react";
import PropTypes from "prop-types";

import { Img, Utils } from "arv-reactcomponents";

const CarouselPreview = props => {
  const { previewImage, closeMobileZoomPreview } = props;

  return (
    <div
      role="presentation"
      id="pdp-mobilezoompreview"
      className="nwc-mobile-scroll nw-maincarousel-mobilezoompreview"
      onClick={closeMobileZoomPreview}
      onKeyDown={Utils.noop}
    >
      <Img id="pdp-mobilezoompreviewimage" src={previewImage} />
    </div>
  );
};

CarouselPreview.propTypes = {
  previewImage: PropTypes.string.isRequired,
  closeMobileZoomPreview: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CarouselPreview,
  component: CarouselPreview,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/MainCarousel/CarouselPreview/index.js